
export function courseSelectorFnMaker(courseId) {
    return session => {
        const course = session.Course.withId(String(courseId));
        if (course === null) {
            return null;
        }
        return Object.assign({}, course.ref, {
            teachers: course.teachers.toRefArray().map(teacher => Object.assign({}, teacher)),
            chapters: course.chapters.toModelArray().map(chapter => 
                (Object.assign({}, chapter.ref, {
                    sections: chapter.sections.toModelArray().map(section => (
                        Object.assign({}, section.ref, {
                            units: section.units.toRefArray().map(unit => Object.assign({}, unit)),
                        })
                    )),
                    period: Object.assign({}, chapter.period.ref),
                })
            )),
        });
    }
}

export function programSelectorFnMaker(programId) {
    return session => {
        const program = session.Program.withId(String(programId));
        if (program === null) {
            return null;
        }
        return Object.assign({}, program.ref, {
            courses: program.courses.toRefArray().map(course => Object.assign({}, course)),
        });
    }
}

export function projectSelectorFnMaker(projectId) {
    return session => {
        const project = session.Project.withId(String(projectId));
        if (project === null) {
            return null;
        }
        return Object.assign({}, project.ref, {chapter: Object.assign({}, project.chapter.ref, {courseTitle: project.chapter.courses.first().title})});
    }
}

export function eventSelectorFnMaker(eventId) {
    return session => {
        const event = session.Event.withId(String(eventId));
        if (event === null) {
            return null;
        }
        return Object.assign({}, event.ref, {chapter: Object.assign({}, event.chapter.ref, {courseTitle: event.chapter.courses.first().title})});
    }
}

export function currentUnitSelectorFnMaker(unitId) {
    return session => {
        const {Unit} = session;
        const unit = Unit.withId(unitId);
        if (!unit) {
            return {
                selectedUnit: null,
                selectedSection: null,
                selectedChapter: null    
            }
        }
        const section = unit.section.at(0);
        const chapter = unit.section.at(0).chapter.at(0);
        const selectedUnit = Object.assign({}, unit.ref);
        const selectedSection = Object.assign({}, section.ref, {
            units: section.units.toRefArray().map(unit => Object.assign({}, unit)),
        });
        const selectedChapter = Object.assign({}, chapter.ref, {
            sections: chapter.sections.toModelArray().map(section => (
                Object.assign({}, section.ref, {
                    units: section.units.toRefArray().map(unit => Object.assign({}, unit)),
                })
            )),
            period: Object.assign({}, chapter.period.ref),
        });
        return {
            selectedUnit,
            selectedSection,
            selectedChapter
        }
    }
}

export function unitsSelectorFnMaker(unitType, unitId) {
    return session => {
        const {Unit} = session;
        let content;
        const unit = Unit.withId(unitId);
        if (!unit) {
            return null;
        }
        let unitContentModel;
        switch (unitType) {
            case 'file':
                content = null;
                unitContentModel = unit.fileType;
                if (unitContentModel) {
                    content = Object.assign({}, unitContentModel.ref, {
                        unit: Object.assign({}, unit.ref)
                    });
                }
                return content;
            case 'video':
                content = null;                    
                unitContentModel = unit.videoType;
                if (unitContentModel) {
                    content = Object.assign({}, unitContentModel.ref, {
                        unit: Object.assign({}, unit.ref)
                    });
                }
                return content;
            case 'quiz':
                content = null;
                unitContentModel = unit.quizType;
                if (unitContentModel) {
                    let quiz = unitContentModel.quiz;
                    if (quiz) {
                        let questions = quiz.questions.toModelArray().map(q => {
                            let choices = q.choices.toModelArray().map(c => {
                                const ref = c.ref;
                                if (!ref.isCheck) {
                                    ref.isCheck = false;
                                }
                                return Object.assign({}, ref);
                            });
                            return Object.assign({}, q.ref, {choices})
                        });
                        content = Object.assign({}, quiz.ref, {
                            questions,
                            unit: Object.assign({}, unit.ref),
                            startAt: unitContentModel.startAt,
                        });
                    }
                }
                return content;
            default:
                return null;
        }
    }
}